<template>
  <v-card
    class="lc-card mx-auto my-3"
    max-width="400"
    min-width="300px"
    rounded="lg"
    relative
  >
    <!-- Header -->
    <div class="lead-card__header">
      <template v-if="userRole !== 'marketing'">
        <div class="lead-card__meta">
          <Tags-And-Create
            :itsImmediate="itsImmediate(lead.created_at, lead.reviewed)"
            :getCreatedAtDate="getCreatedAtDate(lead.created_at)"
            :brex="false"
            :lead="lead"
            view="kanban"
          />
        </div>
        <div class="lead-card__name-row">
          <div class="lead-card__name">
            {{ lead.contact_lead_name ? lead.contact_lead_name : "Sin Nombre" }}
          </div>
          <v-tooltip v-if="lead.contact_external_broker_id" bottom>
            <template v-slot:activator="{ on, attrs }">
              <span class="lead-card__brex-badge" v-bind="attrs" v-on="on">
                <svg
                  version="1.1"
                  id="Layer_1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  x="0px"
                  y="0px"
                  viewBox="0 0 434 444.4"
                  xml:space="preserve"
                >
                  <g>
                    <path
                      d="M337.6,85.1c5.6,0,10.2,4.6,10.2,10.2v237.3c0,5.6-4.6,10.2-10.2,10.2H100.3c-5.6,0-10.2-4.6-10.2-10.2V95.3
    c0-5.6,4.6-10.2,10.2-10.2H337.6 M337.6,72.3H100.3c-12.7,0-23.1,10.3-23.1,23v237.3c0,12.7,10.3,23.1,23.1,23.1h237.3
    c12.7,0,23.1-10.3,23.1-23.1V95.3C360.7,82.6,350.4,72.3,337.6,72.3L337.6,72.3z"
                    />
                  </g>
                  <g>
                    <path
                      d="M152.3,109.9h29.6c9.7,0,17.2,1.9,22.5,5.6c5.2,3.8,7.9,9.1,7.9,16.1c0,3.8-0.9,7.2-2.7,10.1c-1.8,2.9-4.6,5.4-8.5,7.7v0.2
    c5.1,2.1,8.7,4.8,11,8.1c2.2,3.3,3.4,7.4,3.4,12.5c0,8.2-2.4,14.5-7.3,18.9c-4.9,4.4-11.8,6.6-20.7,6.6h-35.1L152.3,109.9
    L152.3,109.9z M182.9,143.6c2.9,0,5.1-0.9,6.8-2.6c1.7-1.8,2.5-4.1,2.5-7.1c0-5.9-3.9-8.8-11.7-8.8H172v18.5L182.9,143.6
    L182.9,143.6z M185.5,180.7c3.2,0,5.7-1.1,7.5-3.2c1.8-2.1,2.8-5,2.8-8.6c0-3.9-1.1-6.8-3.3-8.5c-2.2-1.8-5.8-2.6-10.8-2.6H172
    v22.9H185.5z"
                    />
                    <path
                      d="M227.4,109.9h31.5c19.7,0,29.6,8.1,29.6,24.3c0,5.6-1.1,10.4-3.4,14.4s-5.5,7-9.8,9v0.2c1.5,1.1,2.6,2.1,3.4,3.1
    s1.5,2,2,3.2l12.5,31.8h-20.9l-9.6-25.6c-0.9-2.3-2.1-3.8-3.5-4.5s-4-1.1-7.7-1.1H247V196h-19.8v-86.1H227.4z M256.7,149
    c4,0,7.1-1,9.3-3.1c2.2-2.1,3.3-5.1,3.3-9c0-7.4-4.3-11.2-12.8-11.2h-9.3V149H256.7z"
                    />
                    <path
                      d="M150.1,232.2h58.8v15.7h-39v17.3h34.9v15.7h-34.9v21.5h39v15.7h-58.8L150.1,232.2L150.1,232.2z"
                    />
                    <path
                      d="M242.8,274.2l-25.8-42h22.2l15,25.9l15-25.9h22.2l-25.8,42l26.9,43.9h-21.8l-16.5-27.4l-16.3,27.4h-22L242.8,274.2z"
                    />
                  </g>
                </svg>
              </span>
            </template>
            <span>Broker externo (BREX)</span>
          </v-tooltip>
        </div>
      </template>

      <div v-else class="lead-card__mkt-title">
        <div class="lead-card__name-row">
          <div class="lead-card__name">
            {{ lead.contact_lead_name ? lead.contact_lead_name : "Sin Nombre" }}
          </div>
          <v-tooltip
            v-if="!itsImmediate(lead.created_at, lead.reviewed)"
            bottom
            max-width="200"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                small
                class="amber lighten-3"
                icon
                v-bind="attrs"
                v-on="on"
              >
                <v-icon small color="amber darken-2">
                  mdi-lightning-bolt
                </v-icon>
              </v-btn>
            </template>
            <span>
              Este Lead fue atendido en menos de 5 minutos desde que ingresó al
              sistema
            </span>
          </v-tooltip>
        </div>

        <dl class="lead-card__mkt-grid">
          <div class="lead-card__mkt-item">
            <dt>Origen</dt>
            <dd>{{ lead.zones }}</dd>
          </div>
          <div class="lead-card__mkt-item">
            <dt>Campaña</dt>
            <dd>{{ getMktByField("campaign", "Campaña") }}</dd>
          </div>
          <div class="lead-card__mkt-item">
            <dt>Conjunto</dt>
            <dd>{{ getMktByField("adSet", "Conjunto") }}</dd>
          </div>
          <div class="lead-card__mkt-item">
            <dt>Anuncio</dt>
            <dd>{{ getMktByField("ad", "Anuncio") }}</dd>
          </div>
          <div class="lead-card__mkt-item">
            <dt>Formulario</dt>
            <dd>{{ getMktByField("form", "Formulario") }}</dd>
          </div>
          <div class="lead-card__mkt-item lead-card__mkt-item--full">
            <dt>Observaciones</dt>
            <dd>{{ getMktObservation() }}</dd>
          </div>
        </dl>

        <div class="lead-card__mkt-footer">
          <span class="lead-card__mkt-date">
            Registrado el: {{ dateFormat(lead.created_at) }}
          </span>
          <span class="lead-card__mkt-lifetime">
            {{ getCreatedAtDate(lead.created_at) }}
          </span>
        </div>
      </div>
    </div>

    <!-- Zone / Budget chips -->
    <div class="lead-card__chips">
      <v-chip class="lead-chip lead-chip--zone" label small>
        <v-icon left size="14">mdi-map-marker-outline</v-icon>
        {{ lead.zones }}
      </v-chip>
      <v-chip
        v-if="budget"
        class="lead-chip lead-chip--budget"
        label
        small
        color="green lighten-5"
      >
        <v-icon left size="14" color="green darken-2">mdi-cash-multiple</v-icon>
        <span class="green--text text--darken-3">
          {{ moneyFormatter.format(budget) }} {{ currency ? currency : "" }}
        </span>
      </v-chip>
    </div>

    <!-- Observations -->
    <div class="lead-card__section" v-if="userRole !== 'marketing'">
      <div class="lead-card__obs">
        <v-icon size="16" class="lead-card__obs-icon">
          mdi-note-text-outline
        </v-icon>
        <div
          v-if="observations_detail.message"
          class="lead-card__obs-text text-ellips"
        >
          {{ observations_detail.message }}
        </div>
        <div v-else class="lead-card__obs-text lead-card__obs-text--empty">
          Sin observaciones
        </div>
      </div>

      <div
        v-if="observations_detail.link || observations_detail.contact_link"
        class="lead-card__links"
      >
        <v-menu offset-y v-if="observations_detail.link">
          <template v-slot:activator="{ on: { click } }">
            <v-chip
              class="lead-card__link-chip"
              close
              small
              label
              @click="openLink(observations_detail.link)"
              color="blue darken-1"
              text-color="white"
              close-icon=""
            >
              <v-icon left class="mr-1" size="16">mdi-link-variant</v-icon>
              Enlace
              <v-spacer></v-spacer>
              <v-icon right size="16" @click="click">
                mdi-dots-vertical
              </v-icon>
            </v-chip>
          </template>
          <v-list>
            <v-list-item @click="copyToClipboard(observations_detail.link)">
              <v-list-item-title>Copiar Enlace</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>

        <v-menu offset-y v-if="observations_detail.contact_link">
          <template v-slot:activator="{ on: { click } }">
            <v-chip
              class="lead-card__link-chip"
              close
              small
              label
              @click="openLink(observations_detail.contact_link)"
              :color="
                isWhatsappUrl(observations_detail.contact_link)
                  ? 'green darken-1'
                  : 'blue darken-1'
              "
              text-color="white"
              close-icon=""
            >
              <v-icon
                v-if="isWhatsappUrl(observations_detail.contact_link)"
                left
                class="mr-1"
                size="16"
              >
                mdi-whatsapp
              </v-icon>
              <v-icon v-else left class="mr-1" size="16">
                mdi-link-variant
              </v-icon>
              Enlace de Contacto
              <v-spacer></v-spacer>
              <v-icon right size="16" @click="click">
                mdi-dots-vertical
              </v-icon>
            </v-chip>
          </template>
          <v-list>
            <v-list-item
              @click="copyToClipboard(observations_detail.contact_link)"
            >
              <v-list-item-title>Copiar Enlace</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </div>

    <!-- Discard notes -->
    <div
      class="lead-card__discard"
      v-if="lead.phase === 'discarded' && lead.discard_observations"
    >
      <v-icon size="16" color="red darken-2" class="lead-card__discard-icon">
        mdi-alert-circle-outline
      </v-icon>
      <div class="lead-card__discard-text">
        <span class="lead-card__discard-label">Notas descarte:</span>
        {{ lead.discard_observations }}
      </div>
    </div>

    <v-divider class="lead-card__divider"></v-divider>

    <!-- Source + profile -->
    <div class="lead-card__source-row">
      <div class="lead-card__source">
        <div class="lead-card__source-icon">
          <v-img
            contain
            :src="
              lead.contact && lead.contact.source && lead.contact.source.media
                ? lead.contact.source.media.src
                : ''
            "
            width="18px"
            height="18px"
          >
          </v-img>
        </div>
        <span class="lead-card__source-name">
          {{
            lead.contact && lead.contact.source && lead.contact.source.name
              ? lead.contact.source.name
              : "Indefinido"
          }}
        </span>
      </div>
      <div v-if="userRole !== 'marketing'" class="lead-card__profile-img">
        <v-img
          class="profile-termometer-image"
          contain
          :src="getProfileImage(lead.profile)"
          max-width="32"
          max-height="32"
        ></v-img>
      </div>
    </div>

    <v-divider class="lead-card__divider"></v-divider>

    <!-- Footer actions -->
    <div class="lead-card__footer">
      <div class="lead-card__broker">
        <template v-if="brokerName">
          <v-avatar size="32" class="lead-card__broker-avatar">
            <v-img :src="srcBrokerImage"></v-img>
          </v-avatar>
          <div class="lead-card__broker-info">
            <div class="lead-card__broker-name">
              {{ brokerName.split(" ")[0] }}
            </div>
            <div class="lead-card__comments">
              <svg
                width="16"
                height="16"
                viewBox="0 0 22 22"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M16 2C17.1046 2 18 2.89543 18 4L4 4L4 15.1765C2.89543 15.1765 2 14.281 2 13.1765V4C2 2.89543 2.89543 2 4 2H16Z"
                  fill="#A0A2A7"
                />
                <path
                  d="M14 22L11.3333 19.1765H8C6.89543 19.1765 6 18.281 6 17.1765V8C6 6.89543 6.89543 6 8 6H20C21.1046 6 22 6.89543 22 8V17.1765C22 18.281 21.1046 19.1765 20 19.1765H16.6667L14 22ZM15.8046 17.1765L20 17.1765V8L8 8V17.1765H12.1954L14 19.0872L15.8046 17.1765Z"
                  fill="#A0A2A7"
                />
              </svg>
              <span>{{
                lead && lead.totalComment ? lead.totalComment : 0
              }}</span>
            </div>
          </div>
        </template>
        <div v-else class="lead-card__comments lead-card__comments--standalone">
          <svg
            width="16"
            height="16"
            viewBox="0 0 22 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M16 2C17.1046 2 18 2.89543 18 4L4 4L4 15.1765C2.89543 15.1765 2 14.281 2 13.1765V4C2 2.89543 2.89543 2 4 2H16Z"
              fill="#A0A2A7"
            />
            <path
              d="M14 22L11.3333 19.1765H8C6.89543 19.1765 6 18.281 6 17.1765V8C6 6.89543 6.89543 6 8 6H20C21.1046 6 22 6.89543 22 8V17.1765C22 18.281 21.1046 19.1765 20 19.1765H16.6667L14 22ZM15.8046 17.1765L20 17.1765V8L8 8V17.1765H12.1954L14 19.0872L15.8046 17.1765Z"
              fill="#A0A2A7"
            />
          </svg>
          <span>{{ lead && lead.totalComment ? lead.totalComment : 0 }}</span>
        </div>
      </div>

      <div class="lead-card__profile-pct">
        <v-icon color="accent" size="16">mdi-auto-fix</v-icon>
        <span>{{ profilePercentage }} %</span>
      </div>

      <div class="lead-card__postpone">
        <lead-postpone-action
          :postponed="lead.postponed.date_at"
          :leadId="lead._id"
          :lead="lead"
        />
      </div>
    </div>

    <!-- Closed strip -->
    <div v-if="lead && lead.phase === 'finished'" class="lead-card__closed">
      <v-icon size="16" color="grey darken-1">mdi-trophy</v-icon>
      <span class="lead-card__closed-label">Fecha de cierre:</span>
      <span class="lead-card__closed-date">
        {{ getSpanishDate(lead.updated_at) }}
      </span>
    </div>
  </v-card>
</template>
<script>
import moment from "moment";
moment.locale("es");

export default {
  components: {
    LeadPostponeAction: () => import("@/components/lead/LeadPostpone.vue"),
    TagsAndCreate: () => import("@/components/lead/components/IconTagsLead.vue")
  },
  props: {
    lead: {
      type: Object,
      default: function() {
        return {};
      }
    },
    srcBrokerImage: {
      type: String,
      default: ""
    },
    brokerName: {
      type: String,
      default: ""
    },
    profilePercentage: {
      type: Number,
      default: 0
    },
    budget: {
      type: Number,
      default: 0
    },
    currency: {
      type: String,
      default: ""
    },
    observations: {
      type: String,
      default: ""
    },
    observations_detail: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      iconComments: require("@/assets/comments_icon.svg"),
      moneyFormatter: new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        maximumFractionDigits: 0
      }),
      publicPath: process.env.BASE_URL,
      userRole: localStorage.getItem("user_role") || ""
    };
  },
  filters: {
    // obtiene el valor de un campo en el string mkt, ejemplo:
    // mktString = Campaña: 123 | Conjunto: ABC | Anuncio: XYZ | Formulario: FB Form
    // param = (Campñana, Conjunto, Anuncio, Formulario)
    mktFilter(mktString, param) {
      // comprobar que exista el string mkt
      if (!mktString) return " - ";
      let findParam = param;
      // solo el campo Campaña no tiene '|' al principio
      if (param !== "Campaña") findParam = `| ${param}`;
      // revisar que exista el parametro en el string mkt
      const index = mktString.indexOf(findParam);
      if (index < 0) return " - ";
      let startPos = index + param.length + 1;
      if (param !== "Campaña") startPos += 2; // aumentar otros 2 por separador '|'
      // encontrar el siguiente delimitador '|'
      const indexDelimiter =
        mktString.indexOf("|", startPos) > 0
          ? mktString.indexOf("|", startPos)
          : mktString.length;
      return mktString.substring(startPos, indexDelimiter).trim();
    }
  },
  methods: {
    isWhatsappUrl(url) {
      return url.includes("rply.link");
    },
    friendlyDifferenceTime(timeToParse, allowFutureTime) {
      const format = "DD/MM/YYYY HH:mm:ss";
      let now = moment(new Date(), format);
      let time = moment(new Date(timeToParse), format);
      // retornar en caso de  trasnformar a fecha el tiempo que se mandó como parámetro
      // y se obtuvo un nan
      if (isNaN(time)) return "";

      let friendlyDifference = "";

      let diffMonths = now.diff(time, "months");
      let diffDays = now.diff(time, "days");
      let diffHours = now.diff(time, "hours");
      let diffMinutes = now.diff(time, "minutes");

      if (allowFutureTime) diffMonths = Math.abs(diffMonths);
      if (allowFutureTime) diffDays = Math.abs(diffDays);
      if (allowFutureTime) diffHours = Math.abs(diffHours);
      if (allowFutureTime) diffMinutes = Math.abs(diffMinutes);

      // si para este momento hay un error calculando la diferencia
      if (isNaN(diffMinutes)) return "";

      // en meses
      if (diffMonths > 0) {
        friendlyDifference = diffMonths + " meses";
        if (diffMonths === 1) friendlyDifference = "1 mes";
      } else {
        // en días
        if (diffDays > 0) {
          friendlyDifference = diffDays + " días";
          if (diffDays === 1) friendlyDifference = "1 día";
        } else {
          // en horas
          if (diffHours > 0) {
            friendlyDifference = diffHours + " horas";
            if (diffHours === 1) friendlyDifference = "1 hora";
          } else {
            // en minutos
            if (diffMinutes > 0) {
              friendlyDifference = diffMinutes + " min";
            } else {
              friendlyDifference = "ahora";
            }
          }
        }
      }
      return friendlyDifference;
    },
    itsImmediate(created, reviewed) {
      if (reviewed) {
        if (reviewed.is_reviewed != null && reviewed.is_reviewed) {
          var diff = Math.abs(new Date(reviewed.date_at) - new Date(created));
          const diffMinutes = Math.floor(diff / 1000 / 60);
          return diffMinutes <= 5;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    getSpanishDate(date) {
      if (date === undefined || date === null || date === "") {
        return moment(new Date())
          .locale("es")
          .format("LL");
      } else {
        return moment(new Date(date))
          .locale("es")
          .format("LL");
      }
    },
    getMktObservation() {
      if (!this.lead.hasOwnProperty("observations_detail")) {
        return "--";
      }
      if (!this.lead.observations_detail.hasOwnProperty("message")) {
        return "--";
      }
      if (this.lead.observations_detail.message === "") {
        return "--";
      }
      return this.lead.observations_detail.message;
    },
    getMktByField(fieldMarketing, fieldMkt) {
      if (this.lead.hasOwnProperty("miscellaneous")) {
        if (this.lead.miscellaneous.hasOwnProperty("marketing")) {
          if (
            this.lead.miscellaneous.marketing.hasOwnProperty(fieldMarketing)
          ) {
            return this.lead.miscellaneous.marketing[fieldMarketing];
          } else {
            return "--";
          }
        } else if (this.lead.miscellaneous.hasOwnProperty("mkt")) {
          this.mktFilter(this.lead.miscellaneous.mkt, fieldMkt);
        } else {
          return "--";
        }
      } else {
        return "--";
      }
    },
    mktFilter(mktString, param) {
      // comprobar que exista el string mkt
      if (!mktString) return " - ";
      let findParam = param;
      // solo el campo Campaña no tiene '|' al principio
      if (param !== "Campaña") findParam = `| ${param}`;
      // revisar que exista el parametro en el string mkt
      const index = mktString.indexOf(findParam);
      if (index < 0) return " - ";
      let startPos = index + param.length + 2;
      if (param !== "Campaña") startPos += 2; // aumentar otros 2 por separador '|'
      // encontrar el siguiente delimitador '|'
      const indexDelimiter =
        mktString.indexOf("|", startPos) > 0
          ? mktString.indexOf("|", startPos)
          : mktString.length;
      return mktString.substring(startPos, indexDelimiter).trim();
    },
    openLink(url) {
      window.open(url);
    },
    copyToClipboard(text) {
      navigator.clipboard.writeText(text);
    },
    expiredToday() {
      if (
        this.lead.postponed.date_at === undefined ||
        this.lead.postponed.date_at === null
      ) {
        return false;
      } else {
        let now = new Date();
        let date = new Date(this.lead.postponed.date_at);
        if (
          now.getFullYear() === date.getFullYear() &&
          now.getMonth() === date.getMonth() &&
          now.getDate() === date.getDate()
        ) {
          if (date.getTime() > now.getTime()) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      }
    },
    getPostponedDate(date) {
      let now = new Date();
      let leadDate = new Date(date);
      if (
        now.getDate() === leadDate.getDate() &&
        now.getMonth() === leadDate.getMonth() &&
        now.getFullYear() === leadDate.getFullYear()
      ) {
        // return "Hoy";
        return this.getCreatedAtDate(date);
      } else {
        return this.getCreatedAtDate(date);
      }
    },
    getCreatedAtDate(date) {
      if (date === undefined || date === null || date === "") {
        return new Date().getMonth() === 1
          ? "1 mes"
          : Math.round(new Date().getMonth()) + "meses";
      } else {
        let now = new Date();
        let leadDate = new Date(date);
        let oneDay = 24 * 60 * 60 * 1000;
        if (
          leadDate.getDate() === now.getDate() &&
          leadDate.getMonth() === now.getMonth() &&
          leadDate.getFullYear() === now.getFullYear()
        ) {
          // return "Hoy";
          let diffMinutes = Math.round(Math.abs((leadDate - now) / 60 / 1000));
          if (diffMinutes <= 1) {
            return diffMinutes === 0 ? "Ahora" : "1 min";
          } else {
            if (diffMinutes <= 59) {
              return Math.round(diffMinutes) + " min";
            } else {
              if (Math.round(Math.abs(diffMinutes / 60)) <= 1) {
                return "1 hora";
              } else {
                return Math.round(Math.abs(diffMinutes / 60)) + " horas";
              }
            }
          }
        } else {
          if (Math.round(Math.abs((leadDate - now) / oneDay)) < 30) {
            if (Math.round(Math.abs((leadDate - now) / oneDay)) === 1) {
              return "1 día";
            } else {
              return Math.round(Math.abs((leadDate - now) / oneDay)) + " días";
            }
          } else {
            if (this.monthDiff() > 11) {
              if (this.monthDiff() === 12) {
                return "1 año";
              } else {
                const years = Math.round(this.monthDiff() / 12);
                if (years > 1) {
                  return `${years} años`;
                } else {
                  return `${years} año`;
                }
              }
            } else {
              if (this.monthDiff() === 1) {
                return "1 mes";
              } else {
                return Math.round(this.monthDiff()) + " meses";
              }
            }
          }
        }
      }
    },
    monthDiff() {
      let start = moment(this.lead.postponed.date_at);
      let end = moment();
      if (this.isDelayed(this.lead.postponed.date_at)) {
        let diffDays = moment.duration(start.diff(end)).asDays();
        if (isNaN(diffDays)) {
          return Math.round(new Date().getMonth() + 1);
        } else {
          return Math.round(Math.abs(Math.round(diffDays / 30)));
        }
      } else {
        let diffDays = moment.duration(end.diff(start)).asDays();
        if (isNaN(diffDays)) {
          return Math.round(new Date().getMonth() + 1);
        } else {
          return Math.round(Math.abs(Math.round(diffDays / 30)));
        }
      }
    },
    urifyText(observations) {
      const formatUriText = [];
      let urlRegex = new RegExp(
        "[a-zA-Z0-9]+://([a-zA-Z0-9_]+:[a-zA-Z0-9_]+@)?([a-zA-Z0-9.-]+\\.[A-Za-z]{2,4})(:[0-9]+)?(/.*)?"
      ); //; //
      if (observations) {
        if (urlRegex.test(observations)) {
          let listText = observations.split(" ");
          for (let i = 0; i < listText.length; i++) {
            if (urlRegex.test(listText[i])) {
              if (listText[i].length > 20) {
                formatUriText.push({
                  isUrl: true,
                  url: listText[i],
                  textShow: "Enlace acortado"
                });
              } else {
                formatUriText.push({
                  isUrl: false,
                  url: listText[i],
                  textShow: listText[i]
                });
              }
            } else {
              formatUriText.push({
                isUrl: false,
                url: listText[i],
                textShow: listText[i]
              });
            }
          }
          return formatUriText;
        } else {
          formatUriText.push({
            isUrl: false,
            url: observations,
            textShow: observations
          });
          return formatUriText;
        }
      } else {
        formatUriText.push({
          isUrl: false,
          url: "",
          textShow: ""
        });
        return formatUriText;
      }
    },
    showPostponedIcon() {
      if (
        !this.postponedDate ||
        this.phase === "finished" ||
        this.phase === "discarded"
      ) {
        return false;
      } else {
        return true;
      }
    },
    isNotEmptyPostponedDate(date) {
      if (date === undefined || date === null || date === "") {
        return new Date("2019-04-03");
      } else {
        return date;
      }
    },
    isDelayed(date) {
      // date = moment(date);
      // const today = moment().format("DD-MMM-YYYY");
      // const isBefore = moment(date).isBefore(today + " 23:59:59");
      // return isBefore;
      return new Date(date).valueOf() < new Date().valueOf();
    },
    getProfileImage(profile) {
      let image = "";
      switch (profile) {
        case "A":
          image = `${this.publicPath}50rojo.png`;
          break;
        case "B":
          image = `${this.publicPath}50naranja.png`;
          break;
        case "C":
          image = `${this.publicPath}50amarillo.png`;
          break;
        case "D":
          image = `${this.publicPath}50azul.png`;
          break;
        default:
          image = `${this.publicPath}vacio.png`;
          break;
      }
      return image;
    },
    dateFormat(date) {
      if (date === undefined || date === null || date === "") {
        return moment(new Date())
          .locale("es")
          .format("LLLL");
      } else {
        return moment(new Date(date))
          .locale("es")
          .format("LLLL");
      }
    },
    priceFormat(price, currency) {
      if (parseFloat(price) <= 0 || isNaN(price)) {
        return "-";
      }
      let cu = currency;
      // si se especifico una moneda para todos los precios
      // hacer la conversion
      if (this.currencyPrices && this.currencyPrices !== "") {
        cu = this.currencyPrices;
        if (this.currencyPrices === "MXN" && currency === "USD")
          price = price * 20;
        else if (this.currencyPrices === "USD" && currency === "MXN")
          price = price / 20;
      }
      return (
        parseFloat(price)
          // .toFixed(2)
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
          .concat(" " + cu)
      );
    }
  }
};
</script>
<style scoped>
.lc-card {
  border-radius: 14px !important;
  box-shadow: 0 1px 2px rgba(38, 45, 60, 0.08), 0 1px 3px rgba(38, 45, 60, 0.06) !important;
  transition: box-shadow 0.2s ease, transform 0.2s ease;
  overflow: hidden;
}
.lc-card:hover {
  box-shadow: 0 10px 24px rgba(38, 45, 60, 0.14),
    0 2px 6px rgba(38, 45, 60, 0.08) !important;
  transform: translateY(-2px);
}

/* Header */
.lead-card__header {
  padding: 14px 16px 0;
}
.lead-card__meta {
  margin-bottom: 6px;
}
.lead-card__name-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}
.lead-card__name {
  font-size: 16px;
  font-weight: 600;
  color: var(--v-primary-base, #262d3c);
  line-height: 1.35;
  word-break: break-word;
}
.lead-card__brex-badge {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background: rgba(38, 45, 60, 0.06);
}
.lead-card__brex-badge svg {
  width: 16px;
  height: 16px;
}
.lead-card__brex-badge svg path {
  fill: #6b7280;
}

/* Marketing title */
.lead-card__mkt-title {
  font-size: 14px;
  font-weight: 300;
}
.lead-card__mkt-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px 12px;
  margin: 10px 0 4px;
}
.lead-card__mkt-item--full {
  grid-column: 1 / -1;
}
.lead-card__mkt-item dt {
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #9aa0a6;
  margin-bottom: 2px;
}
.lead-card__mkt-item dd {
  font-size: 13px;
  color: #2d3846;
  margin: 0;
  word-break: break-word;
}
.lead-card__mkt-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 10px;
  padding-top: 8px;
  border-top: 1px dashed rgba(0, 0, 0, 0.08);
  font-size: 12px;
  color: #757575;
}

/* Zone / Budget chips */
.lead-card__chips {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  padding: 10px 16px 0;
}
.lead-chip {
  font-weight: 600 !important;
  border-radius: 8px !important;
}
.lead-chip--zone {
  background: rgba(38, 45, 60, 0.06) !important;
  color: var(--v-primary-base, #262d3c) !important;
}

/* Observations */
.lead-card__section {
  padding: 10px 16px 0;
}
.lead-card__obs {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  background: #f6f7f9;
  border-radius: 10px;
  padding: 8px 10px;
}
.lead-card__obs-icon {
  margin-top: 1px;
  color: #9aa0a6 !important;
  flex-shrink: 0;
}
.lead-card__obs-text {
  font-size: 13px;
  color: #4b5058;
  line-height: 1.4;
}
.lead-card__obs-text--empty {
  color: #b0b3b8;
  font-style: italic;
}
.text-ellips {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.lead-card__links {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 8px;
}
.lead-card__link-chip {
  border-radius: 8px !important;
}

/* Discard notes */
.lead-card__discard {
  display: flex;
  gap: 6px;
  align-items: flex-start;
  margin: 10px 16px 0;
  padding: 8px 10px;
  background: rgba(211, 47, 47, 0.06);
  border-left: 3px solid #d32f2f;
  border-radius: 8px;
}
.lead-card__discard-icon {
  margin-top: 1px;
  flex-shrink: 0;
}
.lead-card__discard-text {
  font-size: 13px;
  color: #4b5058;
  text-align: justify;
}
.lead-card__discard-label {
  font-weight: 700;
  color: #212121;
  margin-right: 4px;
}

.lead-card__divider {
  margin: 12px 16px !important;
}

/* Source row */
.lead-card__source-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
}
.lead-card__source {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}
.lead-card__source-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: #e3f2fd;
  flex-shrink: 0;
}
.lead-card__source-name {
  font-size: 13px;
  font-weight: 500;
  color: #4b5058;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.lead-card__profile-img {
  flex-shrink: 0;
}

/* Footer */
.lead-card__footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
  padding: 10px 16px 14px;
}
.lead-card__broker {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}
.lead-card__broker-avatar {
  flex-shrink: 0;
  border: 2px solid #fff;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.08);
}
.lead-card__broker-info {
  min-width: 0;
}
.lead-card__broker-name {
  font-size: 12px;
  font-weight: 700;
  color: var(--v-primary-base, #262d3c);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 90px;
}
.lead-card__comments {
  display: flex;
  align-items: center;
  gap: 4px;
  color: #9e9e9e;
  font-size: 12px;
}
.lead-card__comments--standalone {
  margin-top: 2px;
}
.lead-card__profile-pct {
  display: flex;
  align-items: center;
  gap: 3px;
  flex-shrink: 0;
  background: rgba(171, 71, 188, 0.1);
  color: var(--v-accent-base, #ab47bc);
  font-weight: 700;
  font-size: 12px;
  padding: 4px 8px;
  border-radius: 20px;
}
.lead-card__postpone {
  flex-shrink: 0;
}

/* Closed strip */
.lead-card__closed {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  background: #fafafa;
  border-top: 1px solid rgba(0, 0, 0, 0.06);
  font-size: 12px;
  color: #757575;
}
.lead-card__closed-label {
  font-weight: 500;
}
.lead-card__closed-date {
  font-weight: 700;
  color: #4b5058;
}
</style>
